import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './list.module.css'

const listPropTypes = {
    children: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    className: PropTypes.string,
    maxItems: PropTypes.number
}

const List = props => {
    const { children, className, maxItems } = props
    const composedClassName = cx(styles['list'], className)
    const slicedChildren = maxItems > 0 ? children.slice(0, maxItems) : children

    return <div className={composedClassName}>{slicedChildren}</div>
}

List.propTypes = listPropTypes

export default List
